import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InsightsMgmtRoutingModule } from './insights-mgmt-routing.module';
import { InsightsMgmtComponent } from './insights-mgmt/insights-mgmt.component';
import { FormsModule } from '@angular/forms';
import { RbUiComponentsModule } from '@inst-iot/bosch-angular-ui-components';
import { GeneralVehiclesComponent } from './general-vehicles/general-vehicles.component';
import { ChargingVehiclesComponent } from './charging-vehicles/charging-vehicles.component';
import { TemperatureVehiclesComponent } from './temperature-vehicles/temperature-vehicles.component';
import { SohcOverTimeChartComponent } from './sohc-over-time-chart/sohc-over-time-chart.component';
import { SohcOverMileageChartComponent } from './sohc-over-mileage-chart/sohc-over-mileage-chart.component';
import { RegenerativeChargingChartComponent } from './regenerative-charging-chart/regenerative-charging-chart.component';
import { ChargedEnergyOverTimeChartComponent } from './charged-energy-over-time-chart/charged-energy-over-time-chart.component';
import { SocDeltaPerChargingProcedureChartComponent } from './soc-delta-per-charging-procedure-chart/soc-delta-per-charging-procedure-chart.component';
import { SocStartChartComponent } from './soc-start-chart/soc-start-chart.component';
import { SocEndChartComponent } from './soc-end-chart/soc-end-chart.component';
import { TemperatureComfortZoneChartComponent } from './temperature-comfort-zone-chart/temperature-comfort-zone-chart.component';
import { CurrentSohcChartEfComponent } from "../../_shared/components/general/current-sohc-chart-ef/current-sohc-chart-ef.component";
import { VehicleMileageChartEfComponent } from "../../_shared/components/general/vehicle-mileage-chart-ef/vehicle-mileage-chart-ef.component";
import { AvgEvEfficiencyChartEfComponent } from "../../_shared/components/general/avg-ev-efficiency-chart-ef/avg-ev-efficiency-chart-ef.component";
import { StressFactorsComponent } from './stress-factors/stress-factors.component';
import { InitialStateOfChargeEfChartComponent } from "../../_shared/components/charging/initial-state-of-charge-ef-chart/initial-state-of-charge-ef-chart.component";
import { EndStateOfChargeEfChartComponent } from "../../_shared/components/charging/end-state-of-charge-ef-chart/end-state-of-charge-ef-chart.component";
import { SocEventsHighEfChartComponent } from "../../_shared/components/charging/soc-events-high-ef-chart/soc-events-high-ef-chart.component";
import { SocEventsLowEfChartComponent } from "../../_shared/components/charging/soc-events-low-ef-chart/soc-events-low-ef-chart.component";
import { SocDeltaPerChargingEfChartComponent } from "../../_shared/components/charging/soc-delta-per-charging-ef-chart/soc-delta-per-charging-ef-chart.component";
import { SharedPipesModule } from 'src/app/_shared/modules/shared-pipes.module';
import { TempComfortZoneChartEfChartComponent } from "../../_shared/components/temperature/temp-comfort-zone-chart-ef-chart/temp-comfort-zone-chart-ef-chart.component";
import { TimeSpentExtremeTempEfChartComponent } from "../../_shared/components/temperature/time-spent-extreme-temp-ef-chart/time-spent-extreme-temp-ef-chart.component";
import { TimeSpentExtremeTempHighEfChartComponent } from "../../_shared/components/temperature/time-spent-extreme-temp-high-ef-chart/time-spent-extreme-temp-high-ef-chart.component";
import { TimeSpentExtremeTempLowEfChartComponent } from "../../_shared/components/temperature/time-spent-extreme-temp-low-ef-chart/time-spent-extreme-temp-low-ef-chart.component";
import { EvConditionPlotComponent } from './ev-condition-plot/ev-condition-plot.component';
import { ChargedEnergyEfChartComponent } from "../../_shared/components/charging/charged-energy-ef-chart/charged-energy-ef-chart.component";
import { StressFactorEfChartComponent } from "../../_shared/components/general/stress-factor-ef-chart/stress-factor-ef-chart.component";
import { EvAtomicAgingComponent } from './ev-atomic-aging/ev-atomic-aging.component';
import { CircularProgressComponent } from 'src/app/_shared/components/utils/circular-progress/circular-progress.component';


@NgModule({
  declarations: [
    InsightsMgmtComponent,
    GeneralVehiclesComponent,
    ChargingVehiclesComponent,
    TemperatureVehiclesComponent,
    SohcOverTimeChartComponent,
    SohcOverMileageChartComponent,
    RegenerativeChargingChartComponent,
    ChargedEnergyOverTimeChartComponent,
    SocDeltaPerChargingProcedureChartComponent,
    SocStartChartComponent,
    SocEndChartComponent,
    TemperatureComfortZoneChartComponent,
    StressFactorsComponent,
    EvConditionPlotComponent,
    EvAtomicAgingComponent
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    /* InsightsMgmtRoutingModule, */
    FormsModule,
    RbUiComponentsModule,
    SharedPipesModule,
    CircularProgressComponent,
    CurrentSohcChartEfComponent,
    VehicleMileageChartEfComponent,
    AvgEvEfficiencyChartEfComponent,
    InitialStateOfChargeEfChartComponent,
    EndStateOfChargeEfChartComponent,
    SocEventsHighEfChartComponent,
    SocEventsLowEfChartComponent,
    SocDeltaPerChargingEfChartComponent,
    TempComfortZoneChartEfChartComponent,
    TimeSpentExtremeTempEfChartComponent,
    TimeSpentExtremeTempHighEfChartComponent,
    TimeSpentExtremeTempLowEfChartComponent,
    ChargedEnergyEfChartComponent,
    StressFactorEfChartComponent
  ],
  exports: [InsightsMgmtComponent],
  providers: [DatePipe]
})
export class InsightsMgmtModule { }
